export default {
  cloudName: process.env.VUE_APP_CLOUDINARY_CLOUD_NAME,
  preset: process.env.VUE_APP_CLOUDINARY_PRESET,
  getCloudinaryUploadUrl(fileType) {
    return `https://api.cloudinary.com/v1_1/${this.cloudName}/${fileType}/upload`;
  },
};
